











































import Vue from 'vue';
import { dialogMaxWidth } from '@/constants';
import { EventBus } from '@/event-bus';

interface Data {
  showConfirmModal: boolean;
  dialogMaxWidth: string;
}

export default Vue.extend({
  name: 'FullscreenWrapper',
  props: {
    confirmBeforeClose: {
      type: Boolean,
      default: false,
    },
    hasChanges: {
      type: Boolean,
      default: false,
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
    suppressClose: {
      type: Boolean,
      default: false,
    },
    modalTitle: {
      type: Array as () => string[],
      default: ['global_title_confirm-close'],
    },
    modalText: {
      type: Array as () => string[],
      default: ['global_text_confirm-close'],
    },
    modalActionCancel: {
      type: Array as () => string[],
      default: ['global_action_confirm-close_cancel', 'global_no'],
    },
    modalActionConfirm: {
      type: Array as () => string[],
      default: ['global_action_confirm-close_confirm', 'global_yes'],
    },
  },
  data(): Data {
    return {
      showConfirmModal: false,
      dialogMaxWidth,
    };
  },
  computed: {
    previousRoute(): string {
      return this.$store.getters.previousRoute;
    },
  },
  mounted() {
    EventBus.$on('closeFullscreenWrapper', this.triggerCloseAction);
  },
  destroyed() {
    EventBus.$off('closeFullscreenWrapper');
  },
  methods: {
    triggerCloseAction(): void {
      if (this.confirmBeforeClose && this.hasChanges) {
        this.showConfirmModal = true;
      } else {
        this.closeWrapper();
      }
    },
    closeModal(): void {
      this.showConfirmModal = false;
    },
    closeWrapper(): void {
      EventBus.$emit('closeOverlayWrapper');
    },
  },
});
